import SharedVariablePreviewPage from "~/areas/projects/components/Variables/VariablePreview/SharedVariablePreviewPage";
export function VariablePreviewPage() {
    return <SharedVariablePreviewPage />;
}
